import { Grid, Card, Typography, Link } from '@mui/material'
import React from 'react'
import colors from '../../../colors'
import { useNavigate } from 'react-router';
import SingleBank from './SingleBank'
import { ReactComponent as TopUpBankOptionsLogo } from '../../../../icons/TopUpBankOptionsLogo.svg';
import { makeStyles } from '@mui/styles';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { texts } from '../../../general/texts'

export const TopUpBankOptions = (props) => {

    const useStyles = makeStyles({
        card:{
            borderRadius:'20px',
            width:'70%',
            boxShadow:'0 0 15px 5px #E5E7EA',
            '@media (max-width: 1440px)' : {width:'80%'}, 
            '@media (max-width: 1024px)' : {width:'80%'},
            '@media (max-width: 699px)' : {width:'90%'}
        },
        header:{
            color:colors.darkBlue,
            fontFamily:'GerberaBold',
            fontSize:'1.5rem',
            paddingLeft:'3%',
            paddingTop:'1%',
            fontSize:'1.5rem'
        }
    })

    const classes = useStyles()
    const navigate = useNavigate()
    return (
        <Grid container item md={8} justifyContent='center' >
            <Card elevation={4} className={classes.card}>
                <Grid container item md={12} direction="column" pb={10} >
                    <Grid container item md={12} xs={12} mt={7} mb={7}>
                        <Grid container item md={1} xs={1} direction="row" justifyContent="center" alignItems="center" ><Link component={'button'} onClick={()=> { navigate(-1)}}><ArrowBackIosNewIcon color='warning' /></Link></Grid>
                        <Grid container item md={10} xs={10} direction="row" justifyContent="center" alignItems="center" >
                            <Grid container direction="column" justifyContent="center" alignItems="center" sx={{width:'65px', height:'65px', borderRadius:'20px', background:colors.veryLightGreen}}><TopUpBankOptionsLogo /></Grid>
                            <Typography color={colors.darkBlue} className={classes.header}>{texts["title-topup-bank"]}</Typography>
                        </Grid>
                    </Grid>
                    <Grid container item md={12} direction='row'justifyContent='center'>
                        {props.bankData.map((bank, index)=>{
                            return <Grid md={4} sm={6} xs={12} item key={index}><SingleBank bankData={bank}/></Grid>
                        })}
                    </Grid>
                </Grid>
            </Card>      
        </Grid>  
     
    )
}

export default TopUpBankOptions
